// see: https://reactabular.js.org/#/column-definition
export const columnsFixtures = [
  {
    property: 'id',
    header: {
      label: 'ID',
    },
  },
  {
    property: 'data',
    header: {
      label: 'Data',
    },
  },
];

export const rowsFixtures = [
  { id: 1, data: 'data-1' },
  { id: 2, data: 'data-2' },
];
